import { Dropdown, FormLayout, TextInput } from 'components/common'
import {
  activeOptions,
  getNestErrorMessage,
} from 'components/aggregatorManagement/utils'
import {
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { chainFormFields, fileSourceTypeOptions, FileSourceType } from './utils'
import ChainFtpConfigForm from './chainFtpConfigForm'

const {
  CHAIN_ID,
  CHAIN_NAME,
  CHAIN_IS_ACTIVE,
  FILE_SOURCE_TYPE,
  FTP_BASE_DIRECTORY,
} = chainFormFields

interface ChainDetailsFormProps {
  register: UseFormRegister<any>
  errors: FieldErrors<any>
  setValue: UseFormSetValue<any>
  watch: UseFormWatch<any>
  chain?: any
  isOptional?: boolean
}

const ChainDetailsForm = ({
  register,
  errors,
  setValue,
  watch,
  chain,
  isOptional = false,
}: ChainDetailsFormProps) => {
  const fileSourceType = watch(FILE_SOURCE_TYPE.key) as FileSourceType

  const isChainFtp = fileSourceType === FileSourceType.CHAIN_FTP

  return (
    <>
      <div className="mb-1 flex items-start justify-between gap-5">
        <h3 className="title">Chain Details</h3>

        <div className="w-full max-w-32">
          <Dropdown
            defaultValue={chain?.[CHAIN_IS_ACTIVE.key] ?? true}
            setValue={setValue}
            options={activeOptions}
            name={CHAIN_IS_ACTIVE.key}
            error={errors?.[CHAIN_IS_ACTIVE.key]?.message as string}
          />
        </div>
      </div>

      <FormLayout>
        <div className="grid gap-x-5 gap-y-3 md:grid-cols-2">
          <TextInput
            required={!isOptional}
            disabled={isOptional}
            label={CHAIN_ID.label}
            register={register}
            name={CHAIN_ID.key}
            error={errors?.[CHAIN_ID.key]?.message as string}
          />

          <TextInput
            required
            label={CHAIN_NAME.label}
            register={register}
            name={CHAIN_NAME.key}
            error={errors?.[CHAIN_NAME.key]?.message as string}
          />
        </div>
      </FormLayout>

      <h3 className="title">FTP Configuration</h3>

      <FormLayout>
        <div className="flex flex-col gap-4">
          <div className="mid-md:w-1/3">
            <Dropdown
              required
              label={FILE_SOURCE_TYPE.label}
              defaultValue={chain?.[FILE_SOURCE_TYPE.key]}
              setValue={setValue}
              options={fileSourceTypeOptions}
              name={FILE_SOURCE_TYPE.key}
              error={errors?.[FILE_SOURCE_TYPE.key]?.message as string}
            />
          </div>

          {!isChainFtp && fileSourceType === FileSourceType.INTERNAL_FTP && (
            <TextInput
              required
              register={register}
              label={FTP_BASE_DIRECTORY.label}
              name={FTP_BASE_DIRECTORY.parentKey + '.' + FTP_BASE_DIRECTORY.key}
              error={getNestErrorMessage(errors, FTP_BASE_DIRECTORY)}
            />
          )}

          {isChainFtp && (
            <ChainFtpConfigForm
              register={register}
              errors={errors}
              setValue={setValue}
              chain={chain}
            />
          )}
        </div>
      </FormLayout>
    </>
  )
}

export default ChainDetailsForm
